import { JsonProperty, Serializable } from "typescript-json-serializer";
import { IDomain } from "./IDomain";

@Serializable()
export abstract class AbstractDomain implements IDomain {

    @JsonProperty()
    clazz: string;

    @JsonProperty()
    multilingualKey: string;

    @JsonProperty()
    createdDate?: number;

    @JsonProperty()
    createdBy?: string;
    
    @JsonProperty()
    modifiedDate?: number;
    
    @JsonProperty()
    modifiedBy?: string;
    
    @JsonProperty()
    idReference?: string;
}